import { render, staticRenderFns } from "./BannerRedes.vue?vue&type=template&id=06177e2e&scoped=true"
import script from "./BannerRedes.vue?vue&type=script&lang=js"
export * from "./BannerRedes.vue?vue&type=script&lang=js"
import style0 from "./BannerRedes.vue?vue&type=style&index=0&id=06177e2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06177e2e",
  null
  
)

export default component.exports